// Documents: API helpers and labels shared by the list, the editor and dialogs.

// A document opened from a packet (/documents/:id?packet=…): every call says so,
// and the server lets the packet's recipients read and edit it.
let packetId = null;
export const setDocPacket = (id) => {
  packetId = id || null;
};

export async function api(path, opts = {}) {
  const res = await fetch(path, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(packetId ? { 'X-Packet': packetId } : {}),
    },
    ...opts,
    body:
      opts.body && typeof opts.body !== 'string'
        ? JSON.stringify(opts.body)
        : opts.body,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.message || `Ошибка ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return data;
}

export async function renderPreview(doc, mode = 'edit') {
  const res = await fetch('/api/documents/render', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...doc, mode }),
  });
  if (!res.ok) throw new Error(`Просмотр: ошибка ${res.status}`);
  return res.text();
}

export const KINDS = [
  ['homework', 'Домашнее задание', 'ДЗ'],
  ['weekly_report', 'Итоги недели', 'Неделя'],
  ['month_plan', 'План на месяц', 'План'],
  ['diagnostics', 'Диагностика', 'Диагностика'],
  ['parent_report', 'Отчёт для родителей', 'Отчёт'],
  ['lesson_plan', 'План урока', 'Урок'],
  ['salary', 'Зарплата', 'Зарплата'],
  ['kpi', 'KPI', 'KPI'],
  ['custom', 'Документ', 'Другое'],
];
export const kindLabel = (k) => (KINDS.find((x) => x[0] === k) || KINDS[8])[1];

export const STATUS = {
  draft: { label: 'Черновик', color: 'default' },
  ready: { label: 'Готов', color: 'info' },
  sent: { label: 'Отправлен', color: 'success' },
};

export const BLOCK_TYPES = [
  ['heading', 'Заголовок'],
  ['text', 'Текст'],
  ['list', 'Список'],
  ['checklist', 'Чек-лист'],
  ['table', 'Таблица'],
  ['callout', 'Плашка'],
  ['kv', 'Цифры (плитки)'],
  ['words', 'Карточки слов'],
  ['image', 'Картинка'],
  ['divider', 'Линия'],
  ['pagebreak', 'Новая страница'],
  ['sheet', 'Лист домашки'],
];
export const blockLabel = (t) =>
  (BLOCK_TYPES.find((x) => x[0] === t) || [t, t])[1];

const rid = () => Math.random().toString(36).slice(2, 10);

export function newBlock(type) {
  const id = rid();
  switch (type) {
    case 'heading':
      return { id, type, level: 2, text: 'Новый раздел' };
    case 'text':
      return { id, type, text: '' };
    case 'list':
      return { id, type, items: [''], ordered: false };
    case 'checklist':
      return { id, type, items: [{ text: '', checked: false }] };
    case 'table':
      return { id, type, columns: ['', ''], rows: [['', '']], caption: '' };
    case 'callout':
      return { id, type, tone: 'tip', title: '', text: '' };
    case 'kv':
      return { id, type, items: [{ label: '', value: '' }] };
    case 'words':
      return { id, type, title: '', items: [{ word: '', translation: '' }] };
    case 'image':
      return { id, type, url: '', caption: '', width: 'full' };
    case 'sheet':
      return {
        id,
        type,
        title: 'NEW SHEET',
        titleRu: '',
        subject: 'Английский',
        steps: [''],
        answers: '',
        phrase: '',
        materialId: '',
        imageId: '',
        docId: '',
        materialName: '',
      };
    default:
      return { id, type };
  }
}

export function fmtWhen(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleString('ru-RU', {
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  });
}
